import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIURLs } from '../api-urls';
import { SharedService } from '../shared/shared.service';

/** Service Injectable */
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  /**
   * Method to initialize Service
   * @param http instance of HttpClient
   * @param urls instance of APIURLs
   * @param shared instance of SharedService
   */
  constructor(private http: HttpClient, private urls: APIURLs, private shared: SharedService) { }

  /** show loader */
  showLoader(message) {
    this.shared.isServiceHit = true;
    this.shared.loadingMessage=(message?message.split('.').join(''):"")||"";
  }

  /** Hide Loader */
  hideLoader() {
    this.shared.loadingMessage="";
    this.shared.isServiceHit = false;
  }

  /**
   * Rest API to Sned Support Email
   * @param request request to send 
   * @param businessUnit Current Business Unit
   */
  supportEmail(request: any, businessUnit: string) {
    let url = this.urls.getSupportURL(businessUnit);
    this.showLoader("Sending support mail..");
    return this.http.post(url, request).pipe(
      map((response: Response) => {
        this.hideLoader(); return response;
      }), catchError((error: HttpErrorResponse) => {
        this.hideLoader(); return throwError(error);
      })
    )
  }
}
